import React, { useEffect } from 'react'
import { setActiveTab } from '../redux/slices/Content/SetActiveTab'
import { useDispatch, useSelector } from 'react-redux'
import Management from './Management';

const QueriesManagement = () => {
    const dispatch = useDispatch();
    // const [contactUsFetch, setContactUsFetch] = useState(false);
    // const [reportsFetch, setReportsFetch] = useState(false);

    const tab = useSelector((state) => state.activeTab.tab);

    useEffect(() => {
        dispatch(setActiveTab('contact'));
    }, [])

    return (
        <section className='main'>
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='common_tabs'>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <button className={`nav-link ${tab === 'contact' ? 'active' : ''}`} id="nav-cmt-1-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-1" type="button" role="tab" aria-controls="nav-cmt-1" aria-selected="true" onClick={() => dispatch(setActiveTab('contact'))}>Contact Us</button>
                                    <button className={`nav-link ${tab === 'reports' ? 'active' : ''}`} id="nav-cmt-2-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-2" type="button" role="tab" aria-controls="nav-cmt-2" aria-selected="false" onClick={() => dispatch(setActiveTab('reports'))}>Reports</button>
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent">
                                {tab == 'contact' && <div className={`tab-pane fade ${tab === 'contact' ? 'show active' : ''}`} id="nav-cmt-1" role="tabpanel" aria-labelledby="nav-cmt-1-tab" tabIndex={0}>
                                    <Management tab={tab} key={`query-${tab}`} />

                                </div>}
                                {tab == 'reports' &&
                                    <div className={`tab-pane fade ${tab === 'reports' ? 'show active' : ''}`} id="nav-cmt-2" role="tabpanel" aria-labelledby="nav-cmt-2-tab" tabIndex={0}>
                                        <Management tab={tab} key={`query-${tab}`} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </section >
    )
}

export default QueriesManagement